module.exports = __webpack_public_path__ + "static/media/logo_full2x.b81b57a4.png";